<div *ngIf="items?.length" class="changes">
  <div class="changes__item" *ngFor="let item of items">
    <span class="text_color-grey">{{ item.changeDate | date : 'dd.MM.yyyy HH:mm' }}</span>
    —
    <span [class.text_bold]="item.userId !== creatorId">{{ item.changeText }}</span>
  </div>
</div>
